import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './navbar4.css'

const Navbar4 = (props) => {
  return (
    <header className={`navbar4-container ${props.rootClassName} `}>
      <header data-thq="thq-navbar" className="navbar4-navbar-interactive">
        <img
          alt={props.imageAlt5}
          src={props.imageSrc5}
          className="navbar4-image"
        />
        <div data-thq="thq-navbar-nav" className="navbar4-desktop-menu">
          <nav className="navbar4-links">
            <Link to="/" className="navbar4-link1 TextContent-Custom">
              {props.link1}
            </Link>
            <a href="#ourservices" className="navbar4-link2">
              {props.link2}
            </a>
            <a href="#contactus" className="navbar4-link4 TextContent-Custom">
              {props.link4}
            </a>
          </nav>
          <div className="navbar4-buttons"></div>
        </div>
        <div data-thq="thq-burger-menu" className="navbar4-burger-menu">
          <svg viewBox="0 0 1024 1024" className="navbar4-icon">
            <path
              d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"
              className=""
            ></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="navbar4-mobile-menu">
          <div className="navbar4-nav">
            <div className="navbar4-top">
              <img
                alt={props.logoAlt}
                src={props.logoSrc}
                className="navbar4-logo"
              />
              <div data-thq="thq-close-menu" className="navbar4-close-menu">
                <svg viewBox="0 0 1024 1024" className="navbar4-icon2">
                  <path
                    d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
                    className=""
                  ></path>
                </svg>
              </div>
            </div>
            <nav className="navbar4-links1">
              <span className="thq-link thq-body-small">{props.link1}</span>
              <span className="thq-link thq-body-small">{props.link2}</span>
              <span className="thq-link thq-body-small">{props.link3}</span>
              <span className="thq-link thq-body-small">{props.link4}</span>
              <span className="thq-link thq-body-small">{props.link5}</span>
            </nav>
          </div>
          <div className="navbar4-buttons1">
            <button className="thq-button-filled">Login</button>
            <button className="thq-button-outline">Register</button>
          </div>
        </div>
      </header>
    </header>
  )
}

Navbar4.defaultProps = {
  link4: 'Contact',
  imageAlt1: 'image',
  action2: 'Action 2',
  imageSrc: '4c6f52f3-2d99-4009-8db7-b00b5506d887',
  imageAlt: 'image',
  logoSrc:
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/84ec08e8-34e9-42c7-9445-d2806d156403/fac575ac-7a41-484f-b7ac-875042de11f8?org_if_sml=1&force_format=original',
  link5: 'Link5',
  imageSrc3: 'bce28ac9-7703-4359-9dd7-cc2adab58d0b',
  imageAlt4: 'image',
  imageSrc4: '4c6f52f3-2d99-4009-8db7-b00b5506d887',
  imageSrc5: '/logowhite2-200h.png',
  logoAlt: 'Cloud Computing Professional Logo',
  imageSrc1: 'e19eef61-e7f7-462a-8c36-4341868f8a65',
  imageAlt5: 'image',
  imageSrc2: '614c25b8-0a3a-47a0-9086-0242a25c193b',
  rootClassName: '',
  action1: 'Action 1',
  imageAlt2: 'image',
  imageAlt3: 'image',
  link2: 'Services',
  link3: 'About',
  link1: 'Home',
}

Navbar4.propTypes = {
  link4: PropTypes.string,
  imageAlt1: PropTypes.string,
  action2: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  logoSrc: PropTypes.string,
  link5: PropTypes.string,
  imageSrc3: PropTypes.string,
  imageAlt4: PropTypes.string,
  imageSrc4: PropTypes.string,
  imageSrc5: PropTypes.string,
  logoAlt: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageAlt5: PropTypes.string,
  imageSrc2: PropTypes.string,
  rootClassName: PropTypes.string,
  action1: PropTypes.string,
  imageAlt2: PropTypes.string,
  imageAlt3: PropTypes.string,
  link2: PropTypes.string,
  link3: PropTypes.string,
  link1: PropTypes.string,
}

export default Navbar4
